import aleksandra_boratynska from "../assets/pg_employees/aleksandra_boratynska.jpg";
import arkadiusz_slodowski from "../assets/pg_employees/arkadiusz_slodowski_160x160.jpg";
import dorota from "../assets/pg_employees/dorota_wachnicka_160x160.jpg";
import jan_dziekonski from "../assets/pg_employees/jan_dziekonski_160x160.png";

export interface IPGEmployee {
    name: string;
    role: string;
    phone: string;
    email: string;
    picture: string;
}

export const pgEmployees = {
    arkadiusz_slodowski: {
        name: "Arkadiusz Słodkowski",
        role: "common.pr_manager",
        phone: "+48 607 030 311",
        email: "a.slodkowski@rynekpierwotny.pl",
        picture: arkadiusz_slodowski
    },
    arkadiusz_slodowski_pr: {
        name: "Arkadiusz Słodkowski",
        role: "common.pr_manager",
        phone: "+48 607 030 311",
        email: "pr@rynekpierwotny.pl",
        picture: arkadiusz_slodowski
    },
    aleksandra_boratynska: {
        name: "Aleksandra Boratyńska",
        role: "common.customer_consultant",
        phone: "+48 532 758 886",
        email: "a.boratynska@rynekpierwotny.pl",
        picture: aleksandra_boratynska
    },
    dorota_wachnicka: {
        name: "Dorota Wachnicka",
        role: "common.customer_service_manager",
        phone: "+48 784 930 517",
        email: "d.wachnicka@rynekpierwotny.pl",
        picture: dorota
    },
    jan_dziekonski: {
        name: "Jan Dziekoński",
        role: "common.chef_economist_of_rynekpierwotnypl",
        phone: "",
        email: "",
        picture: jan_dziekonski
    }
};
